import { Control, Controller, UseFormResetField } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

// local imports
import lactationIcon from 'assets/icons/baby-gray.svg'
import { IHealthLocationList } from 'types/HealthType'
import { IFilteredLactationRoomList, ILactationRoomSearch } from 'types/LactationType'
import {
  DropdownWrapper,
  StyledCustomDropdown,
} from 'components/home/on-campus-services/coiffeur/coiffeur-search-modal/styled'

interface ILactationFormProps {
  control: Control<ILactationRoomSearch>
  resetField: UseFormResetField<ILactationRoomSearch>
  locationList: IHealthLocationList[] | undefined
  roomList: IFilteredLactationRoomList[] | []
}

function valueTemplate(options: IFilteredLactationRoomList, props: any) {
  return <div className="selectedVal">{options?.name || props?.placeholder}</div>
}

export default function LactationRoomSearchForm({ control, resetField, roomList, locationList }: ILactationFormProps) {
  const { t } = useTranslation()

  return (
    <div className="d-flex flex-column gap-2">
      {/* Location */}
      <Controller
        name="locationId"
        control={control}
        render={({ field }) => (
          <DropdownWrapper>
            <label className="autocomplete-title">{t('most-used-words.location')}</label>
            <i className="autocomplete-icon p-input-icon-left pi pi-map-marker"></i>
            <StyledCustomDropdown
              id="lactationLocation"
              emptyMessage={t('most-used-words.option-not-found')}
              emptyFilterMessage={t('most-used-words.option-not-found')}
              name="locationId"
              placeholder={t('input-texts.choose-location')}
              optionLabel="name"
              optionValue="id"
              valueTemplate={(opt, props) => valueTemplate(opt, props)}
              options={locationList}
              value={field.value}
              onChange={(e) => {
                field.onChange(e.value)
                resetField('lactationRoom')
              }}
            />
          </DropdownWrapper>
        )}
      />

      {/* Lactation Room */}
      <Controller
        name="lactationRoom"
        control={control}
        render={({ field }) => (
          <DropdownWrapper>
            <label className="autocomplete-title">{t('input-texts.lactation-room')}</label>
            <img
              className="autocomplete-icon p-input-icon-left"
              src={lactationIcon}
              alt="logo"
              width={18}
              height={18}
            />
            <StyledCustomDropdown
              id="lactationRoomDropdown"
              emptyMessage={t('most-used-words.option-not-found')}
              emptyFilterMessage={t('most-used-words.option-not-found')}
              name="lactationRoom"
              placeholder={t('input-texts.choose-lactation-room')}
              optionLabel="name"
              options={roomList}
              value={field.value}
              valueTemplate={(opt, props) => valueTemplate(opt, props)}
              onChange={(e) => {
                field.onChange(e.value)
              }}
            />
          </DropdownWrapper>
        )}
      />
    </div>
  )
}
